import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowQueryDto } from '@interfaces/queries';
import { WorkflowItemQueriesService } from '@workflow/queries/services/workflow-item-queries.service';

@Component({
	selector: 'workflow-query-panel',
	templateUrl: './query-panel.component.html',
	styleUrls: ['./query-panel.component.scss'],
})
export class QueryPanelComponent {
	public readonly opened$: Observable<WorkflowQueryDto[]>;
	public readonly responded$: Observable<WorkflowQueryDto[]>;
	
	constructor(
		workflowItemQueriesService: WorkflowItemQueriesService,
	) {
		this.opened$ = workflowItemQueriesService.query$({states:['opened']});
		this.responded$ = workflowItemQueriesService.query$({states:['responded']});
	}
}
